module.exports = __webpack_public_path__ + "static/media/decoration-gray-bottom-1.0446ea06.svg";